import type { Block, ParagraphData } from "../../../../models/ManualAuthoring";
import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./step.css";

export default function StepEdit({
  block,
  stepNumber = "1.",
  onDone,
}: {
  block: Block;
  stepNumber?: string;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-step pdf-step--editing">
      <span className="pdf-step__num">{stepNumber}</span>

      <div className="pdf-step__text">
        <StructuredInlineTextEditor
          textParts={data.textParts || []}
          onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
          onDone={onDone}
        />
      </div>
    </div>
  );
}
